import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCustomerAuth } from '../context/CustomerAuthContext';
import { UserPlus, AlertCircle } from 'lucide-react';

const CustomerRegister = () => {
  const { register } = useCustomerAuth();
  const navigate = useNavigate();
  const [data, setData] = useState({ name: '', email: '', phone: '', company: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (data.password.length < 6) { setError('Password minima 6 caratteri'); return; }
    setLoading(true);
    try {
      await register(data);
      navigate('/carrello');
    } catch (err) {
      setError(err.response?.data?.detail || 'Errore registrazione');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-10 fade-in">
      <div className="w-full max-w-md bg-white border border-neutral-200 rounded-xl p-8 shadow-sm">
        <div className="flex items-center gap-2 mb-6">
          <UserPlus className="text-[#d62828]" size={22} />
          <h1 className="text-2xl font-black brand-text text-neutral-900">Registrati</h1>
        </div>
        {error && (
          <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded text-red-800 text-sm flex items-center gap-2">
            <AlertCircle size={16} /> {error}
          </div>
        )}
        <form onSubmit={submit} className="space-y-3">
          {[
            ['Nome *', 'name', 'text', true, 'name'],
            ['Email *', 'email', 'email', true, 'email'],
            ['Telefono', 'phone', 'tel', false, 'tel'],
            ['Azienda / Produzione', 'company', 'text', false, 'organization'],
            ['Password *', 'password', 'password', true, 'new-password'],
          ].map(([label, k, type, required, autocomplete]) => (
            <div key={k}>
              <label className="block text-sm font-bold text-neutral-700 mb-1">{label}</label>
              <input type={type} required={required} autoComplete={autocomplete} value={data[k]} onChange={(e) => setData({ ...data, [k]: e.target.value })} className="w-full px-4 py-2.5 border border-neutral-300 rounded focus:outline-none focus:ring-2 focus:ring-[#d62828]/30 focus:border-[#d62828]" />
            </div>
          ))}
          <button type="submit" disabled={loading} className="w-full px-5 py-3 bg-[#d62828] text-white font-bold rounded hover:bg-[#b41f1f] transition-colors disabled:opacity-60">
            {loading ? 'Registrazione...' : 'Crea account'}
          </button>
        </form>
        <p className="text-sm text-neutral-600 text-center mt-6">
          Hai già un account?{' '}
          <Link to="/cliente/login" className="text-[#d62828] font-bold">Accedi</Link>
        </p>
      </div>
    </div>
  );
};

export default CustomerRegister;
